<app-view-and-sign-pdf
  [isReadonly]="details()?.isReadonly"
  [documentLoadable]="documentLoadable$ | async"
  (instance)="onInstanceInitialization($event)"
  (documentLoaded)="onDocumentLoaded()"
  (annotationChanged)="onAnnotationChanged($event)"
  (editSignature)="onEditSignature()"
  (deleteSignature)="onDeleteSignature()"
  (fieldChanged)="onFieldsUpdated($event)"
  [ngClass]="{'app-view-and-sign-pdf_mobile': (isMobile$ | async)}"
>
</app-view-and-sign-pdf>
